import { useState, useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import { Switch, Route, useParams } from 'react-router-dom'

import {
  clearStorageFacilities,
  clearStorageFacility
} from '@/actions/operations/storageFacility'

import { tableReducer, tableInitialState } from './state'

import ShippingMethod from '../ShippingMethod'

import Table from './Table'
import Form from './Form'

const MODULE_PATH = '/operations/:zone+/inventory/storage-facilities'

function StorageFacilityManagement() {
  const dispatch = useDispatch()

  const params = useParams()

  const [state, dispatchState] = useReducer(tableReducer, tableInitialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    return () => {
      dispatch(clearStorageFacility())
      dispatch(clearStorageFacilities())
    }
  }, [dispatch])

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Switch>
      <Route path={`${MODULE_PATH}/shipping-methods`}>
        <ShippingMethod
          organizationId={state.organizationId}
          storageFacilityId={state.storageFacilityId}
          backPath={modulePath}
        />
      </Route>
      <Route
        path={[`${MODULE_PATH}/create`, `${MODULE_PATH}/update/:itemId`]}
        exact={true}
      >
        <Form
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
        />
      </Route>
      <Route path={MODULE_PATH} exact={true}>
        <Table
          state={state}
          dispatchState={dispatchState}
          modulePath={modulePath}
        />
      </Route>
    </Switch>
  )
}

export default StorageFacilityManagement
